import regex from '../constants/system.keys';

function groupBy(list) {
  const map = new Map();
  list.forEach(item => {
    const key = JSON.stringify({
      lat: item.lat,
      lng: item.lng
    });
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
}

export default data => {
  /**
   * @input list devices have lat and lng
   *
   */
  let res = [];
  groupBy(data).forEach((devices, coors) => {
    const { lat, lng } = JSON.parse(coors);
    res.push({ lat, lng, devices });
  });
  return res;
};

export const onlyLettersAndNumbers = (str) => {
  return Boolean(str.match(regex.isName));
}
